import React, { FunctionComponent } from 'react'

const AuthLayout: FunctionComponent = ({ children }) => {
    return (
        <div className='grid lg:grid-cols-8 h-screen'>
            <div className='lg:col-span-3 h-full'>
                <div className='flex items-center justify-center h-full flex-col w-10/12 sm:w-7/12 md:w-6/12 lg:w-10/12 xl:w-8/12 mx-auto'>
                    {children}
                </div>
            </div>
            <div className='hidden lg:block col-span-5 custom-bg'></div>
        </div>
    )
}

export default AuthLayout
